import { Helmet } from "react-helmet";
import Navbar from "../../Include/Navbar/Navbar";
import Breacumb from "./Breadcumb";
import Numberstate from "../Home/Numberstate";
// import Testimonial from '../Home/Testimonial'
import Faq from "../Home/Faq";
import Contact from "../Home/Contact";
import Footer from "../../Include/Footer/Footer";
import seoMetaData from "../../Include/Seo/seoMetaData";

export default function About() {
  const { title, description } = seoMetaData.about;
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href="https://www.cloudkode.com/about-us" />
        <script type="application/ld+json">
          {`
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "I’m looking for a cloud services provider, how can you help?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We offer end-to-end cloud solutions including consultation, architecture, deployment, and ongoing management tailored to your business needs."
        }
      },
      {
        "@type": "Question",
        "name": "Do you offer support after project completion?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, we offer ongoing support and maintenance packages to ensure your services remain up-to-date and secure."
        }
      },
      {
        "@type": "Question",
        "name": "How secure are your cloud solutions?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Our cloud solutions follow industry best practices with multi-layered security including encryption, firewalls, and regular audits."
        }
      },
      {
        "@type": "Question",
        "name": "Can you migrate our existing systems to the cloud?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Absolutely! We specialize in smooth and secure migrations with minimal downtime."
        }
      },
      {
        "@type": "Question",
        "name": "Do you work with startups as well as enterprises?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, we tailor our solutions for both startups and large enterprises, with scalable and cost-effective options."
        }
      }
    ]
  }
    `}
        </script>
      </Helmet>
      <Navbar />
      <Breacumb />
      <Numberstate sectionId="about-numberstate" />
      {/* <Testimonial/> */}
      <Faq />
      <Contact />
      <Footer />
    </>
  );
}
